// extracted by mini-css-extract-plugin
module.exports = {"avatar":"WhyServiceWithUs_avatar__8SC47"};